<template>

  <div class="item_main">

    <div class="title">1.进入测试</div>
    <div class="content">点击弹窗中的测试模式，进入测试页面。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/entertest.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    <div class="title">2.测试方法</div>
    <div class="content">每个单词有四个选项，点击选择，正确显示蓝色背景，错误则显示红色背景。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/test.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">3.设置</div>
    <div class="content">点击测试页面右下角的设置按钮，弹出设置弹窗，可设置测试方式、排序、播放、音效等。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/testsetup.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">4.筛选</div>
    <div class="content">点击测试页面左下角的筛选按钮，可选择需要测试的单词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/testfilter.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">5.测试模式</div>
    <div class="content">测试模式有看英选义、听音选义、看义选英，可根据需要选择。
  
    </div>

    <div class="title">6.加入生词</div>
    <div class="content">点击拼词页面加入生词按钮，可加入生词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/addnew.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">7.加入熟知</div>
    <div class="content">点击拼词页面加入熟知按钮，可加入熟知词。
  
    </div>


    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/addknown.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    
   





    </div>
  

  
 



  
  

  
    
  </template>
  
  <script setup>

  </script>
  
  <style scoped>

  .item_main {
    font-size: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    text-align: left;
  }

  .title {
    font-size: 0.45rem;
    font-weight: bold;
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
  .second_title {
    font-size: 0.42rem;
    
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .content {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  
  </style>